export default "__VITE_PUBLIC_ASSET__511b0c30__"